import { useEffect } from "react";
import { Outlet } from "react-router";
import { ActivityLogging } from "./components/ActivityLogging";
import SystemMessages from "./components/SystemMessages";
import { AppProvider } from "./contexts/AppContext";
import { AuthProvider } from "./contexts/AuthContext";
import { CustomerProvider } from "./contexts/CustomerContext";
import { SystemMessagesProvider } from "./contexts/SystemMessagesContext";
import { ThemeModeProvider } from "@atomic/ui-kit";
import { parquetWorkerManager } from "./utils/parquet-worker-manager";

function App() {
  // Global cleanup on app unmount to prevent memory leaks
  useEffect(() => {
    return () => {
      // Clean up parquet worker
      parquetWorkerManager.terminate();
    };
  }, []);

  // Warm the parquet worker POOL eagerly at app mount so each worker's WASM
  // fetch+compile starts immediately and overlaps auth + bundle parse —
  // finishing before the first mapping/source parquet parse needs it (ported
  // from dashmart; see MAX_PARQUET_WORKERS in parquet-worker-manager).
  useEffect(() => {
    parquetWorkerManager.warm();
  }, []);

  return (
    <ThemeModeProvider>
      <AuthProvider>
        <CustomerProvider>
          <AppProvider>
            <SystemMessagesProvider>
              <ActivityLogging />
              <Outlet />
              <SystemMessages />
            </SystemMessagesProvider>
          </AppProvider>
        </CustomerProvider>
      </AuthProvider>
    </ThemeModeProvider>
  );
}

export default App;
